import { Images } from '@/assets';
import { MultiLineText } from '@/components/text/MultiLineText';
import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const RoleExplain = () => {
  const { t, i18n } = useTranslation();
  return (
    <Container>
      <OnOffWrap>
        <TitleImgWrap>
          <img src={Images.OnOffImg} alt="service-registration-onoff-img" />
        </TitleImgWrap>
        <TitleDesc>
          <MultiLineText
            translationKey={t('registerTheServicesYouWantToOfferToR2Players')}
          />
        </TitleDesc>
      </OnOffWrap>
      <RoleSection data-en={i18n.language === 'en'}>
        <RoleBox>
          <CenterImg src={Images.CenterImg} alt="service-center-img" />
          <RoleWrap>
            <RoleTitleWrap>
              <RoleTitle>
                R2 Center service:
                <span> {t('manufacturingDesign')}</span>
              </RoleTitle>
              <RoleDesc>
                <MultiLineText
                  translationKey={t(
                    'youCanRegisterManufacturingAndDesignServicesForCrownBridgeAndR2Guid'
                  )}
                />
              </RoleDesc>
            </RoleTitleWrap>
          </RoleWrap>
        </RoleBox>
        <RoleBox data-planner={true}>
          <PlannerImg src={Images.PlannerImg} alt="service-planner-img" />
          <RoleWrap>
            <RoleTitleWrap>
              <RoleTitle>
                R2 Planner service:
                <span> {t('designOnly')}</span>
              </RoleTitle>
              <RoleDesc>
                <MultiLineText
                  translationKey={t(
                    'youCanSelectCrownBridgeAndR2GuideServices'
                  )}
                />
              </RoleDesc>
            </RoleTitleWrap>
          </RoleWrap>
        </RoleBox>
      </RoleSection>
    </Container>
  );
};

export default RoleExplain;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12.53px;
`;

const OnOffWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 29px;
  padding-left: 83px;
`;

const TitleImgWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`;

const TitleDesc = styled.div`
  font-size: 15px;
  line-height: 120%;
  color: #6b97f8;
  text-align: start;
`;

const RoleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 0 34px 81px;
  &[data-en='true'] {
    padding: 0 0 31px 81px;
  }
`;

const RoleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 61.91px;
  color: #6b97f8;
  flex: 1;
  &[data-planner='true'] {
    color: #df67e2;
    gap: 61.85px;
  }
`;

const RoleTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 6px;
`;

const RoleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
`;

const CenterImg = styled.img`
  padding-left: 11px;
  width: 68.09px;
  height: 102px;
`;

const PlannerImg = styled.img`
  width: 79.15px;
  height: 89px;
`;

const RoleTitle = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 15px;
  line-height: 120%;
  > span {
    font-weight: ${fonts.weight.semiBold};
  }
`;

const RoleDesc = styled.div`
  font-size: 15px;
  line-height: 120%;
`;
